import React, { useContext, useEffect } from "react";
import ApplicationContext from "../../../context/ApplicationContext";
import { Button, Modal } from "react-bootstrap";

import { IReminderModalProps } from "./IReminderModalProps";
import { startSnookerTable, tableReminder } from "../../../services/Service";
import {
  Dropdown,
  DropdownItemProps,
  Message,
  MessageHeader,
} from "semantic-ui-react";
import { ISnookerTable } from "../../../types/ISnookerTable";

export interface IStartTimeModalProps {
  close(): void;
  table: ISnookerTable;
  show: boolean;
}

export const StartTimeModal: React.FC<IStartTimeModalProps> = (
  props: IStartTimeModalProps
): JSX.Element => {
  const context = useContext(ApplicationContext);

  const [payValue, setPayValue] = React.useState("");
  const [saving, setSaving] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [hour, setHour] = React.useState(0);
  const [minutes, setMinutes] = React.useState(0);
  const [selectedDate, setSelectedDate] = React.useState(new Date());

  var dateNow = selectedDate.toISOString().substring(0, 10);

  useEffect(() => {
    const dt = new Date();
    setError(false);
    setHour(dt.getHours());
    setMinutes(dt.getMinutes());
  }, [props.show]);

  const hourOptions: DropdownItemProps[] = [];
  const minOptions: DropdownItemProps[] = [];

  for (let i = 0; i < 24; i++) {
    let displayText = i.toString();
    if (i < 10) {
      displayText = "0" + i.toString();
    }
    hourOptions.push({ key: i, text: displayText, value: i });
  }

  for (let i = 0; i < 60; i++) {
    minOptions.push({ key: i, text: i, value: i });
  }

  const onHourChange = (event: any, result: any) => {
    const { name, value } = result || event.target;
    setHour(parseInt(value));
  };

  const onMinutesChange = (event: any, result: any) => {
    const { name, value } = result || event.target;
    setMinutes(parseInt(value));
  };

  const errorMessage = () => (
    <>
      <Message negative>
        <MessageHeader>Error starting table</MessageHeader>
        <p>
          Please check your network (internet). If the error persist please
          contact support
        </p>
      </Message>
    </>
  );

  const viewContent = () => (
    <>
      {error ? errorMessage() : <></>}

      <div
        style={{
          width: "100%",
          justifyContent: "center",
          fontSize: 16,
          display: "flex",
        }}
      >
        <>
          <input
            value={dateNow}
            type="date"
            onChange={(e) => setSelectedDate(new Date(e.target.value))}
          />
          <span style={{ padding: 10 }}></span>

          <Dropdown
            placeholder="Hours"
            selection
            onChange={onHourChange}
            options={hourOptions}
            value={hour}
          />
          <span style={{ padding: 10 }}></span>

          <Dropdown
            placeholder="Minutes"
            selection
            onChange={onMinutesChange}
            options={minOptions}
            value={minutes}
          />
        </>
      </div>
    </>
  );

  const customerModal = (): JSX.Element => {
    return (
      <>
        <Modal show={props.show} onHide={() => props.close()} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Start time</Modal.Title>
          </Modal.Header>
          <Modal.Body>{viewContent()}</Modal.Body>
          <Modal.Footer className="modal-footer">
            <div>
              <Button
                variant="secondary"
                style={{
                  width: 100,
                  height: 50,
                  fontSize: 20,
                }}
                onClick={() => props.close()}
              >
                Cancel
              </Button>
            </div>

            <Button
              variant="success"
              style={{
                width: 300,
                height: 50,
                fontSize: 20,
              }}
              onClick={() => startTable()}
            >
              Start table
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  };

  async function startTable() {
    const dt = new Date(selectedDate);
    dt.setHours(hour);
    dt.setMinutes(minutes);

    const response = await startSnookerTable(
      props.table.uuid,
      context.AuthenticatedUser.getToken(),
      dt
    );

    if (!response) {
      setError(true);
      return;
    }
    props.close();
  }

  return (
    <>
      <>{customerModal()}</>
    </>
  );
};
